import { Identity } from "@/infrastructure/backend/userIdentity";
import { Out } from "@/infrastructure/frontent/clientMessage";
import { LightLog, LogTyp } from "./log/LightLog";

export enum AppConst {
  NotApplicable = "Diese Funtkion darf nicht benutz werden",
  MinDate = "2000-01-01"
}

export function ignorePersonProductTableRecreate() {
  return true
}

//--> 2026
const CurrentUserIdKey = "currentUserId"

export function setCurrentUserId() { 
   if (Identity.isUserRole()) {
      try {
        localStorage.setItem(CurrentUserIdKey, Identity.getIdentity().getValue().UserId)
      } catch (e) {
        LightLog.add("AppConst.setCurrentUserId", `Exeception: ${e}`, LogTyp.Fehler)
      }
    }
}

export function getCurrentUserId() {
  try {
      return localStorage.getItem(CurrentUserIdKey) ?? ""
  } catch(e) {
    LightLog.add("AppConst.getCurrentUserId", `Exeception: ${e}`, LogTyp.Fehler)
  }
  return ""
}

export function clearCurrentUserId() {
  try {
    localStorage.removeItem(CurrentUserIdKey)
  } catch (e) {
    LightLog.add("AppConst.getCurrentUserId", `Exeception: ${e}`, LogTyp.Fehler)
  }
}
//<-- 2026


export function getApplicationConstText(appConst: AppConst): string {
  return appConst.toString();
}



export const StartVersion = "2.11"
export const CodeVersion = "2.11"
export const MinDbVersion = 20



export const disableButtonTime = 1200


export class AppStateContext {
  private static isSaveButtoEnabled = true
  private static storedElement: any = {}

  public static isSaveButtonEnabled() {
    return AppStateContext.isSaveButtoEnabled
  }
}
